import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import RequireAuth from '../src/utils/RequireAuth';
import { Provider } from 'react-redux';
import store from './app/store';
import { ToastContainer } from 'react-toastify';

createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <Provider store={store}>
    <RequireAuth>
      <RouterProvider router={router} />
      <ToastContainer />
    </RequireAuth>
  </Provider>
  // </React.StrictMode>
);
